import "./resources.css"
import { Box, Grid } from '@mui/material';
import ResourceCard from "./ResourceCard";
import { useGetResourcesHeadersQuery, useGetResourcesQuery } from "../../../services/resourcesApi";
import CircularProgress from "@mui/material/CircularProgress";
import AppContext from './../../../context/AppProvider';
import { useContext } from 'react';
import InformationMessage from '../../../components/modals/InformationMessage';
import { useState } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { create } from "yup/lib/Reference";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const tabsStyles={
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  width: "100%",
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ResourcesList = ({ resources }) => {
  const { data: resourceHeaders, error: resourceHeaderError, isLoading: resourceHeaderIsLoading } = useGetResourcesHeadersQuery();
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  let tabIndexFromQuery = Number(query.get("tab_index") || 0);
  const [tabIndex, setTabIndex] = useState(tabIndexFromQuery);
  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
    query.set("tab_index", newValue);
    history.push({ search: query.toString() });
  };

  function createTabs(){
    let tabs=[];
    resourceHeaders?.forEach((rh, index) => {
      tabs.push(<Tab label={rh.name} {...a11yProps(index)} />)
    })
    return tabs;
  }

  const toggleResource = (id) => {
    resources = resources.map((resource) => {
      if (resource.id === id) {
        resource.show = !resource.show
      }
      return resource
    })
  }
  let activeResources = resources.filter(r => r.active === true).sort((a, b) => a.orderNumber - b.orderNumber);
  let resourcesByHeaderId={};
  resourceHeaders?.forEach((rh) => {
    resourcesByHeaderId[rh.id]= activeResources.filter( r=> r.resourceHeaderId === rh.id);
  })


  return (
    <Box
      sx={tabsStyles}
    >
      <Grid sx={{ width: "100%" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "var(--light-yellow)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            aria-label="basic tabs example"
            textColor="inherited"
            indicatorColor="primary"
          >
            {
              createTabs()
            }
            
          </Tabs>
        </Box>

        {
          resourceHeaders?.map((rh, index) => (
            <TabPanel value={tabIndex} index={index}>
              {
                resourcesByHeaderId[rh.id].length === 0 ?
                  <h4>There are no Resources.</h4>
                : resourcesByHeaderId[rh.id].map((resource) => (
                <ResourceCard key={resource.id} resource={resource} toggleResource={toggleResource} />
              ))}
            </TabPanel>
          ))
        }

      </Grid>
    </Box>
  )
}

const ResourcesPage = () => {

  const { data: resources, isError, isLoading, error } = useGetResourcesQuery();
  const { data: resourceHeaders, error: resourceHeaderError, isLoading: resourceHeaderIsLoading } = useGetResourcesHeadersQuery();
  const { message } = useContext(AppContext)

  let children;

  if (error || resourceHeaderError) {
    children = <h4>There was an error loading the resources. {JSON.stringify(error || resourceHeaderError)}</h4>
  }
  else if (isLoading || resourceHeaderIsLoading) {
    children = <CircularProgress sx={{ color: "var(--orange)" }} />
  } else if (resources?.filter(r => r.active === true)?.length === 0) {
    children = <h4>No Resources available.</h4>
  }
  else if (resources) {
    children = <ResourcesList resources={resources} />
  }

  console.log("resources: ", resources, "isError: ", isError, "isLoading: ", isLoading, "error: ", error)

  return (
    <Box className="resources-page">
      <Box sx={{ width: { xs: "100%", sm: "100%", md: "90%", lg: "80%", xl: "70%" } }} >
        {
          (message?.title !== "" && message?.message !== "" && message?.enabled && message?.showOnAllPages)
          &&
          <InformationMessage
            title={message?.title}
            message={message?.message}
          />
        }
        <h3 style={{ color: 'var(--orange)' , marginBottom: "1em"}} >Resources</h3>
        {children}
      </Box>
    </Box>
  );
}

export default ResourcesPage;